import godsData from '../smite2_gods_data.json';
import itemsData from '../smite2_items_data.json';

// Filter and organize item types
const filterItemsByType = (type) => {
  return itemsData.items.filter(item => item.type === type && item.is_enabled === 1);
};

// Get all tier 3 items (items that are not in any recipe_of arrays)
const getTier3Items = () => {
  return itemsData.items.filter(item => 
    item.recipe_of.length === 0 && 
    item.recipes.length > 0 && 
    item.is_enabled === 1 &&
    item.type !== 'Starter' && 
    item.type !== 'Consumable' &&
    item.type !== 'Relic' &&
    // Ensure the item has the proper Tier3 tag
    item.tags?.ItemTier?.includes('Tier3')
  );
};

// Get all starters
const getStarters = () => {
  return filterItemsByType('Starter');
};

// Get all relics (actives)
const getRelics = () => {
  return filterItemsByType('Relic');
};

// Get all gods
const getAllGods = () => {
  return godsData.gods;
};

// Generate a random build
const generateRandomBuild = () => {
  const allGods = getAllGods();
  const randomGod = allGods[Math.floor(Math.random() * allGods.length)];
  
  const starters = getStarters();
  const relics = getRelics();
  const tier3Items = getTier3Items();
  
  const randomStarter = starters[Math.floor(Math.random() * starters.length)];
  const randomRelic = relics[Math.floor(Math.random() * relics.length)];
  
  const randomItems = [];
  // Select 6 unique tier 3 items
  const itemsCopy = [...tier3Items];
  for (let i = 0; i < 6; i++) {
    if (itemsCopy.length === 0) break;
    const randomIndex = Math.floor(Math.random() * itemsCopy.length);
    randomItems.push(itemsCopy[randomIndex]);
    itemsCopy.splice(randomIndex, 1);
  }
  
  return {
    god: randomGod,
    starter: randomStarter,
    relic: randomRelic,
    items: randomItems
  };
};

export {
  getAllGods,
  getStarters,
  getRelics,
  getTier3Items,
  generateRandomBuild
}; 